module.exports = __webpack_public_path__ + "img/bespoke123_06.1277c26a.jpg";